import React from "react";
import styles from "./index.module.css";
const Marquee = () => {
  const listOne = [
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new1.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new2.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new3.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new4.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new5.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new28.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new7.png",
    "https://xiuxiupro-material-center.meitudata.com/material/image/6761623d764052236.webp",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new10.png",
    "https://xiuxiupro-material-center.meitudata.com/material/image/67616212833a34738.webp",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new11.png",
  ];
  const listTwo = [
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new12.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new13.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new14.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new15.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new6.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new17.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new18.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new19.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new20.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new21.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new22.png",
  ];
  const listThree = [
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new23.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new24.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new25.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new26.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new27.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new16.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new29.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new30.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new31.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new32.png",
    "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new33.png",
  ];

  const renderList = (list: string[]) => {
    return (
      <>
        <div className={styles.inner}>
          {list.map((v, idx) => {
            return (
              // eslint-disable-next-line @next/next/no-img-element
              <img
                className={styles.item}
                key={`${v}-first`}
                width={374}
                height={208}
                loading="lazy"
                src={v}
                alt={`template-${idx}`}
              />
            );
          })}
        </div>
        <div className={styles.inner}>
          {list.map((v, idx) => {
            return (
              // eslint-disable-next-line @next/next/no-img-element
              <img
                className={styles.item}
                key={`${v}-second`}
                width={374}
                height={208}
                loading="lazy"
                src={v}
                alt={`template-second-${idx}`}
              />
            );
          })}
        </div>
      </>
    );
  };

  return (
    <div className={styles.marquee}>
      <div className={styles.marqueeTitle}>提供风格多样的高级感PPT模板</div>

      <div className={styles.marqueeContent}>
        <div className={styles.marqueeContentItem}>{renderList(listOne)}</div>
        <div
          className={`${styles.marqueeContentItem} ${styles.marqueeContentItemRight}`}
        >
          {renderList(listTwo)}
        </div>
        <div className={styles.marqueeContentItem}>{renderList(listThree)}</div>
      </div>
    </div>
  );
};

export default React.memo(Marquee);
